export const INTEREST_CHECK_FORM = "https://forms.gle/2WxUGPPynrqq2jZX6"